module.exports = __webpack_public_path__ + "media/country_flags/ad-bde4d90f.png";